import * as a from "react";
import { typeOfComponent as t } from "./atoms-v21131.js";
var s = function(f) {
  return f.map(function(r) {
    switch (typeof r) {
      case "string":
        return r;
      case "function":
        return t(a.createElement(r));
      case "object":
      default: {
        var e = a.createElement(r), n = t(e);
        return n === "react.forward_ref" ? t(e.type.render(e.props, e.ref)) : t(r);
      }
    }
  });
};
export {
  s as processTypes
};
